import {IEntity} from './entity';

export interface IEntityList<T extends IEntity> {
    totalRows: number;
    items: T[];
}

export class EntityList<T extends IEntity> implements IEntityList<T> {
    items: T[];
    totalRows: number;

    constructor(data: IEntityList<T>) {
        this.items = data.items;
        this.totalRows = data.totalRows;
    }
}
